import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataHandlerService } from 'src/app/Services/data-handler.service';
import { RolesService } from 'src/app/Services/roles.service';
import { TranslationService } from 'src/app/Services/translation.service';
import { AlertService } from 'src/app/Services/alert.service';
import { IPaymentPackageData } from 'src/app/Models/IPaymentPackageData';
import { PAYMENT_PACKAGES_PATH_KEY } from 'src/app/Constants/request-path-keys';
import {
  PAYMENT_PACKAGE_CREATE,
  PAYMENT_PACKAGE_DELETE,
  PAYMENT_PACKAGE_UPDATE,
  PAYMENT_PACKAGE_VIEW,
  SUCCESS_KEY,
  TR_DELETE_MESSAGE_KEY,
  TR_PAYMENT_PACKAGES_KEY
} from 'src/app/Constants/main-keys';
import { guid } from '@progress/kendo-angular-common';

@Component({
  selector: 'app-payment-packages-table',
  templateUrl: './payment-packages-table.component.html',
  styleUrls: ['./payment-packages-table.component.scss']
})
export class PaymentPackagesTableComponent implements OnInit {
  paymentpackage_view: boolean;
  paymentpackage_create: boolean;
  paymentpackage_update: boolean;
  paymentpackage_delete: boolean;
  deletePaymentPackageId: number;
  deletePaymentPackageName: string;
  userRoles: Array<string> = [];
  paymentPackages: Array<IPaymentPackageData> = [];
  deleteSpinnerId: string = guid();

  constructor(
    private dataHandlerService: DataHandlerService,
    private rolesService: RolesService,
    private translationService: TranslationService,
    private modalService: NgbModal,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.userRoles = this.rolesService.userRoles;
    this.setRoles();
    this.translationService.setPageTitle(TR_PAYMENT_PACKAGES_KEY);

    this.getPaymentPackages();
  }

  setRoles() {
    this.userRoles.forEach(role => {
      switch (role) {
        case PAYMENT_PACKAGE_VIEW:
          this.paymentpackage_view = true;
          break;
        case PAYMENT_PACKAGE_CREATE:
          this.paymentpackage_create = true;
          break;
        case PAYMENT_PACKAGE_UPDATE:
          this.paymentpackage_update = true;
          break;
        case PAYMENT_PACKAGE_DELETE:
          this.paymentpackage_delete = true;
          break;
      }
    });
  }

  getPaymentPackages() {
    this.dataHandlerService.getDataWithSpinner(PAYMENT_PACKAGES_PATH_KEY).then(response => this.paymentPackages = response);
  }

  confirmDelete(content, id: number, name: string): void {
    this.deletePaymentPackageId = id;
    this.deletePaymentPackageName = name;
    this.modalService.open(content).result;
  }

  delete(): void {
    if (!this.paymentpackage_delete) { return; }
    this.dataHandlerService.deleteData(this.deletePaymentPackageId, PAYMENT_PACKAGES_PATH_KEY, this.deleteSpinnerId).then(() => {
      this.alertService.translateAndAlertMessage(TR_DELETE_MESSAGE_KEY, SUCCESS_KEY);
      this.getPaymentPackages();
      this.modalService.dismissAll();
    });
  }

}
